import gql from 'graphql-tag';

export const CreateWhiteboardMutation = gql`
	mutation CreateWhiteboardMutation(
		$spaceKey: String!
		$parentId: ID
		$contentSpecificCreateInput: [ContentSpecificCreateInput!]
		$title: String
	) {
		createContentContextual(
			input: {
				spaceKey: $spaceKey
				parentId: $parentId
				contentSpecificCreateInput: $contentSpecificCreateInput
				status: CURRENT
				type: "whiteboard"
				title: $title
			}
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
